<template>
  <div id="app">
    <van-tabs v-model="active">
      <van-tab title="吃" name="1">
        <van-form @submit="onSubmit" style="margin-top:20px" >
          <van-cell-group inset>
            <van-field clearable name="radio" label="输出方式">
              <template #input>
                <van-radio-group v-model="checked" direction="horizontal">
                  <van-radio name="1">竖排</van-radio>
                  <van-radio name="2">横排</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              v-model="userqq"
              name="价格"
              label="价格"
              placeholder="复制群里发的"
              :rules="[{ required: true, message: '复制群里价格' }]"
            />
            <van-field clearable name="stepper" label="多少">
              <template #input>
            <van-stepper v-model="userArea" step="0.1" min="0.0" max="1.7" :decimal-length="1" />

                <!-- <van-stepper integer v-model="userArea" step="0.1" :decimal-length="1" min="0.2" max="1.2"/> -->
                <!-- <van-stepper integer v-model="userArea" :min="min" :max="max"/> -->
              </template>
            </van-field>
            <!-- <van-field
              v-model="detail"
              name="区服详细信息"
              label="区服详细信息"
              :rules="[{ required: true, message: '未获取到区服信息' }]"
              disabled
            /> -->
            <!-- <van-field clearable name="stepper" label="吃多少">
              <template #input>
                <van-stepper v-model="num"  :min="0.2"/>
              </template>
            </van-field> -->
          </van-cell-group>
          <div style="margin: 16px;">
            <van-button round block  color="rgba(25,137,250)" native-type="submit">
              生成
            </van-button>
          </div>
        </van-form>
      </van-tab>
      <van-tab title="账单测试版" name="2">
        <van-field center name="stepper" label="多少">
          <template #input>
            <van-stepper v-model="userArea" step="0.1" min="-1.7" max="1.7" :decimal-length="1" />
          </template>
        </van-field>
        <van-form style="margin-top:20px" >
          <van-cell-group style="margin-bottom: 10px;" v-for="(item,index) in peiceList" :key="index" inset>
            <van-field :disabled="index===0" clearable v-model="item.time" label="时间" placeholder="例如：05:20" center>
              <van-button v-if="index!== 0" slot="button" type="primary" size="small" @click="fnChooseTime(index)">
                手动选择
              </van-button>
            </van-field>
            <van-field clearable v-model="item.price" placeholder="复制整段价格" />
          </van-cell-group>
          <van-button type="info" size="small" style="margin-left: 18px;" @click.stop="fnAdd">新增一行</van-button>
          <div style="margin: 16px;">
            <van-button round block  color="rgba(25,137,250)" @click="onSubmit1">
              生成
            </van-button>
          </div>
        </van-form>
      </van-tab>
    </van-tabs>
    <van-dialog
      v-model="showDialog"
      show-cancel-button
      title="结果"
      class="copyStr"
      @confirm="onCancel"
      @cancel="onConfirm"
      :data-clipboard-text="copyMsg"
      confirm-button-text="复制"
      cancel-button-text="关闭"
    >
    <div v-html="message2" style="margin: 12px; padding: 10px; background: #eee">
    </div>
    </van-dialog>
    <van-action-sheet v-model="timeShow">
        <van-datetime-picker
            v-model="currentTime"
            type="time"
            :min-hour="0"
            :max-hour="23"
            @confirm="timeConfirm"
            @cancel="timeCancel"
        />
    </van-action-sheet>
  </div>
</template>

<script>
import { configIos,configA } from './const'
import Clipboard from 'clipboard';
export default {
  name: 'App',
  data() {
    return {
      active: '1',
      showDialog: false,
      userqq: '',
      checked: '1',
      userArea: 0.2,
      num: 1,
      min:1,
      detail: '',
      max: 120,
      url:'',
      message2: '',
      copyMsg: '',
      timeIndex: 0,
      peiceList: [{
        time: '00:00',
        price: '',
      }],
      timeShow: false,
      currentTime: '12:30',
      prefixes: ['x','x1','xx','x2','钱包速额1000','怪额','微','微1','V50','V10起']
    }
  },
  mounted() {
  },
  // watch: {
  //   checked: {
  //     handler (nV) {
  //       this.fnChange()
  //     },
  //     immediate: true,
  //   },
  //   userArea: {
  //     handler (nV) {
  //       this.fnChange()
  //     },
  //     immediate: true,
  //   },
  // },
  methods: {
    timeCancel() {
      this.timeShow = false
    },
    timeConfirm(value) {
      console.log(value)
      this.peiceList[this.timeIndex].time = value
      this.timeCancel()
    },
    fnChooseTime(index) {
      this.timeIndex = index
      this.timeShow = true
    },
    fnAdd() {
      this.peiceList.push({
        time: '',
        price: '',
      })
    },
    fnNumber (str) {
      const match = str.match(/(?:\d+\.\d+\s+)?(.+)/);
      const numbersStr = match[1];
      const numbers = numbersStr.split('/');
      return numbers;
    },
    onConfirm(){
      this.showDialog = false
      // window.location.href = this.url
    },
    onCancel (){
      const clipboard = new Clipboard('.copyStr');
      clipboard.on('success', e => {
        this.$toast.success('复制成功');
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        alert("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy()
      })
    },
    fnChange(e){
      if(!this.userArea && this.userArea !== 0) {return}
      if(this.checked === '2') {
        this.min = 1
        this.max = configIos.length
        this.detail = configIos.filter(item => item.id == this.userArea)[0].value
      } else if (this.checked === '1'){
        this.min = 0
        this.max = 450
        this.detail = configA.filter(item => item.id == this.userArea)[0].value
      }
    },
    formatNumber(num) {
      return num.toFixed(3).replace(/\.?0+$/, '')
    },
    onSubmit1() {
      const arr = []
      let error = false
      this.peiceList.forEach((item,index)=>{
        if(!item.time && item.price) {
          error = true
          this.$toast.fail('有一行填了价格没填日期')
        } else if (item.time && !item.price) {
          error = true
          this.$toast.fail('有一行填了日期没填价格')
        } else if(item.time && item.price) {
          const num  = this.fnNumber(item.price)
          if(num.length === this.prefixes.length) {
            arr.push({time: item.time, price: num})
          } else {
            error = true
            this.$toast.fail(`第${index + 1}行价格格式不对`)
          }
        }
      })
      if(error) return
      console.log(arr)
      // 遍历前缀数组
      const resultArr = [];

      this.prefixes.forEach((prefix, index) => {
        arr.forEach(timeItem => {
          let price = this.formatNumber(Number(timeItem.price[index]) / 1000 + this.userArea/100)
          let timeStr = timeItem.time;
          resultArr.push(`${prefix}${timeStr}/${price}`);
        });
      });

      const resultStr = resultArr.join('\n');
      this.message2 = resultArr.join('<br>');
      this.copyMsg = resultStr
      this.showDialog = true
    },
    onSubmit(){
      const str = this.userqq
      const matchResult = str.match(/^(\d+\.\d+)\s+(.+)$/)
      const dateStr = matchResult? matchResult[1] : '今天';
      const numbers = this.fnNumber(str)
      console.log('aaa', numbers)
      if(numbers.length !== this.prefixes.length) {
        this.$toast.fail('当前渠道长度和价格长度不一样请联系管理员更新')
        return
      }
      let str1 = dateStr
      if(this.checked === '2') {
        str1 = str1 + '   '
        const arr = []
        numbers.forEach(item => {
          let num = (Number(item) + (this.userArea * 10)).toFixed(0);
          const processed = num.toString().replace(/0+$/, '');
          arr.push(processed);
        })
        str1 = str1 + arr.join('/')
        this.copyMsg = str1
      } else {
        str1 = `${str1}<br>`
        let str2 = `${dateStr}\n`
        numbers.forEach((item,index) => {
          let num = (Number(item) + (this.userArea * 10)).toFixed(0);
          const processed = num.toString().replace(/0+$/, '');
          str1 = str1 + `${this.prefixes[index]}———${processed}<br>`
          str2 = str2 + `${this.prefixes[index]}———${processed}\n`
        })
        this.copyMsg = str2
      }
        this.message2 = str1
        this.showDialog = true
      // if(this.checked === '1'){
      //   alert('安卓让用户自己发起代付吧')
      // } else{
      //   this.url = 'https://pay.qq.com/h5/index.shtml?m=buy&c=game&pf=mds_private-__mds_private_aW9zd2hpdGVsaXN0_t25.default-iap&appid=1450002260&zoneid='+Math.round(2010+this.userArea)+ '&n='+this.num+'&as=1&u='+this.userqq+'&author=Askook'
      //   this.showDialog = true
      //   this.$nextTick(()=>{
      //     QrCode.toCanvas(this.$refs.codeImg, this.url)
      //   })
      // }
    },
  }
}
</script>

<style>
html,body{
  height: 100%;
}
#app {
  width: 100%;
  background: #f6f6f6;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
}
.van-dialog__content > div{
    max-height: 230px;
    overflow-y: auto;
}
</style>
